import { TemplateData, TemplateParams } from '.';

const accountExpirationWarning = ({
  defaultPlaceholders,
  messages
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.accountExpirationWarningContent}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.accountExpirationWarningSubject}`
  },
  placeholders: {
    expirationDate: {
      label: messages.commonExpirationDate,
      example: '27.3.2024'
    },
    expirationTimeInDays: {
      label: messages.siteSettingsAccountExpirationTimeInDays,
      example: '3'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeAccountExpirationWarning
});

export default accountExpirationWarning;
